import lf from 'lovefield'

export function simu_installations_const_installations (schemaBuilder) {
  schemaBuilder.createTable('simu_installations_const_installations')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_installations_id', lf.Type.INTEGER)
      .addColumn('const_installations_id', lf.Type.INTEGER)
      .addColumn('quantite', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true)
      .addNullable(['quantite']);
}

/*
CREATE TABLE IF NOT EXISTS `simu-installations` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `pk` int(11) NOT NULL COMMENT 'en mètres',
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuInstallations_constInstallations.schema.js